import { Component, output } from '@angular/core';
import { ButtonComponent } from 'libs/shared/components/ui/button/button';

@Component({
  selector: 'agr-signin-form',
  imports: [ButtonComponent],
  templateUrl: './signin-form.html',
})
export class SigninForm {
  
  signInFlux = output();

  signIn(){
    this.signInFlux.emit();
  }

}
